<div class="confirmation-dialog-wrapper flex justify-center items-center flex-col">
  <i class="fal fa-times close-icon" (click)="close()"></i>
  <i class="fal fa-triangle-exclamation"></i>
  <p>{{message}}</p>
  <div class="flex items-center gap-3 mt-5">
    <app-accent-button text="Cancelar" [selected]="false" (click)="close()"></app-accent-button>
    <app-accent-button text="Confirmar" [selected]="true" (click)="confirm()" *ngIf="confirmButton"></app-accent-button>
  </div>
</div>